import { render, staticRenderFns } from "./ContratoForm.vue?vue&type=template&id=3687b5e9&scoped=true"
import script from "./ContratoForm.vue?vue&type=script&lang=js"
export * from "./ContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687b5e9",
  null
  
)

export default component.exports